import { Component, Inject } from "@angular/core";

import { MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface PasswordExpirationDialogData
{
    readonly expirationMessage: string;
}

@Component({
    selector: "password-expiration-dialog-component",
    templateUrl: "./passwordExpirationDialog.tmpl.html",
    styleUrls: [
        "./passwordExpirationDialog.component.scss"
    ],
    standalone: false
})
export class PasswordExpirationDialogComponent
{
    constructor(
        @Inject(MAT_DIALOG_DATA)
        private readonly data: PasswordExpirationDialogData
    ) { }

    get expirationMessage(): string
    {
        return this.data.expirationMessage;
    }
}
